/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 1/13/16,
 * Refactored by kyang on 10/3/19.
 */

function LiveFeedSearchViewController(
    this: JS5Object,
    $location: JS5Object,
    $scope: JS5Object,
    BreadcrumbService: JS5Object,
    LivefeedsResourceFactory: JS5Object,
    ModalService: JS5Object,
    NavbarUtilService: JS5Object,
    NotificationService: JS5Object,
    SearchFilterService: JS5Object,
    uiGridConstants: JS5Object
) {

    const openLiveFeedEditView = (liveFeed: JS5Object) => {
        BreadcrumbService.addBreadcrumb({
            location: '/system/livefeeds/search',
            name: 'Live Feeds',
            params: angular.copy($location.search())
        });
        $location.url('/system/livefeeds/edit/' + liveFeed.id);
    };

    //======//
    // Grid //
    //======//

    let gridColumns = [
        {
            field: 'name',
            name: 'Name',
            minWidth: 250,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'elementalAddress',
            name: 'Elemental Address',
            minWidth: 250,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'profileName',
            name: 'Profile Name',
            minWidth: 250,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'profilePermaLinkID',
            name: 'Profile PermaLink ID',
            minWidth: 250,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    const gridRowSelectionChangedHandler = (row: JS5Object) => {
        if (row.isSelected) {
            this.selectedLiveFeed = row.entity;
        } else {
            this.selectedLiveFeed = null;
        }
    };

    const filterGrid = (searchText: string) => {
        this.searchText = searchText.toLowerCase();
        this.gridApi.grid.refresh();
    };

    const processGridFilter = (renderableRows: JS5Object[]) => {
        renderableRows.forEach((row: JS5Object) => {
            row.visible = (this.searchText)? row.entity.name.toLowerCase().indexOf(this.searchText) !== -1 : true;
        });
        return renderableRows;
    };

    this.currentGridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: false,
        enableVerticalScrollbar: 2,
        columnDefs: gridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged($scope, gridRowSelectionChangedHandler);
            gridApi.grid.registerRowsProcessor(processGridFilter, 200);
        }
    };

    this.onRowDblClick = (row: JS5Object) => {
        openLiveFeedEditView(row.entity);
    };


    //=========//
    // Toolbar //
    //=========//

    const cloneSelectedLiveFeed = () => {
        this.loadingIndicator.show = true;
        LivefeedsResourceFactory.clone({id: this.selectedLiveFeed.id})
            .$promise.then((clone: JS5Object) => {
                this.loadingIndicator.show = false;
                openLiveFeedEditView(clone);
            });
    };

    const deleteLiveFeed = () => {
        this.loadingIndicator.show = true;
        LivefeedsResourceFactory.toggleArchive({id: this.selectedLiveFeed.id})
            .$promise.then(() => {
                queryForGridData();
            });
    };

    const deleteMessage = 'Are you sure you want to delete ';
    const cloneMessage = 'Are you sure you want to clone ';
    const openConfirmModal = (messageText: string, title: string, handler: JS5Function) => {
        messageText += this.selectedLiveFeed.name + '?';
        title += this.selectedLiveFeed.name + '?';
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, handler);
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => this.searchPerms.read && this.searchPerms.write,
            onClick: () => {
                openLiveFeedEditView({id: -1});
            }
        }, {
            label: 'Edit',
            enabled: () => {
                return (
                    this.searchPerms.read &&
                    this.searchPerms.write &&
                    !!this.selectedLiveFeed
                );
            },
            onClick: () => {
                openLiveFeedEditView(this.selectedLiveFeed);
            }
        }, {
            label: 'Clone',
            enabled: () => {
                return (
                    this.searchPerms.clone.read &&
                    this.searchPerms.clone.write &&
                    !!this.selectedLiveFeed
                );
            },
            onClick: () => {
                openConfirmModal(cloneMessage, 'Clone ', cloneSelectedLiveFeed);
            }
        }, {
            label: 'Delete',
            enabled: () => this.searchPerms.read && !!this.selectedLiveFeed,
            onClick: () => {
                openConfirmModal(deleteMessage, 'Delete ', deleteLiveFeed);
            }
        }
    ];


    //=================//
    // Lifecycle Hooks //
    //=================//

    const handleGridDataQuery = (gridData: JS5Object[], responseHeaders: JS5Object) => {
        if($location.search().searchText) {
            filterGrid($location.search().searchText);
        }
        this.loadingIndicator.show = false;
    };

    const queryForGridData = () => {
        this.loadingIndicator.show = true;
        this.selectedLiveFeed = null;
        this.currentGridOptions.data = LivefeedsResourceFactory.query({}, handleGridDataQuery);
        return this.currentGridOptions.data.$promise;
    };

    this.$onInit = () => {
        this.selectedLiveFeed = null;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        this.searchPerms = {
            read: true,
            write: true,
            clone: {
                read: true,
                write: true,
                batch: {
                    write: true
                }
            }
        };

        SearchFilterService.populateCriteriaFromLocationSearch();
        NavbarUtilService.viewSearchFunction = filterGrid;
        queryForGridData();
    };

}

angular.module('prism-ui.livefeed').component(
    'livefeedSearchview',
    {
        bindings: {},
        controller: LiveFeedSearchViewController,
        templateUrl: 'system/livefeed/searchView/livefeed-searchview-template.html',
    });

